import { Box } from '@mui/material';
const TheGuarantorsLogoCompact = '/images/logo-compact-grey.svg';

export const Logo = () => {
  return (
    <Box
      id="tg-navbar-logo"
      aria-label="TheGuarantors"
      sx={{
        width: '36px',
        height: '36px',
        padding: '6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
      }}
    >
      <img src={TheGuarantorsLogoCompact} alt="TheGuarantors" width="24px" height="24px" />
    </Box>
  );
};
